// src/guards/AuthGuard.tsx
import { Loader } from "pages/loader"
import { useAppSelector } from "store"
import { Navigate } from "react-router-dom"
import { FC, PropsWithChildren } from "react"
import { AuthSelectors } from "store/slices/authSlice"
import LoaderScreen from "ui/loader-screen"
import { loaderBg } from "assets/images"
import { loaderLogo } from "assets/icons"

const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const status = useAppSelector(AuthSelectors.selectStatus)
  const isLoaded = useAppSelector((state) => state.app.isLoaded)

  if (status === "idle" || status === "authenticating") {
    return (
      <LoaderScreen logo={loaderLogo} backgroundImage={loaderBg} progress={0} />
    )
  }

  if (status !== "authenticated") {
    return <Navigate to="/login" replace />
  }

  if (!isLoaded) {
    return <Loader />
  }

  return <>{children}</>
}

export default AuthGuard
